import VenteParConteneur from "../Ventes/venteParConteneur";

const ShowVenteByConteneur = () => {
    return (
        <div className="row">
            <VenteParConteneur id={-1} />
        </div>
    );
}

export default ShowVenteByConteneur;